// extracted by mini-css-extract-plugin
export default {"history":"PurchaseJourney_history__P-bq4","section_summary":"PurchaseJourney_section_summary__jv1Uz"};